import { render, staticRenderFns } from "./Titlebar.vue?vue&type=template&id=0d5e2028&scoped=true&"
import script from "./Titlebar.vue?vue&type=script&lang=js&"
export * from "./Titlebar.vue?vue&type=script&lang=js&"
import style0 from "./Titlebar.vue?vue&type=style&index=0&id=0d5e2028&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5e2028",
  null
  
)

export default component.exports